<template>
  <v-container id="guia-update-form" class="pa-0">
    <v-row class="ma-0">
      <v-col class="py-0 px-2" cols="2">
        <div class="title-form">Data da autorização</div>
        <v-menu
          ref="dtA"
          v-model="dtA"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
        > <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormattedA"
              dense
              v-mask="'##/##/####'"
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              label
              outlined
              v-bind="attrs"
              v-on="on"
              append-icon="mdi-calendar-blank"
              @blur="dateA = parseDate(dateFormattedA)"
              :rules="[formRules.typeDateFormated]"
            ></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="dateA" @input="formData.dadosAutorizacao.dataAutorizacao = dateA" no-title scrollable></v-date-picker>
        </v-menu>
      </v-col>

      <v-col class="py-0 px-2" cols="3">
        <div class="title-form">Senha</div>
        <v-text-field
          v-model="formData.dadosAutorizacao.senha"
          outlined
          dense
          maxlength="20"
        ></v-text-field>
      </v-col>

      <v-col class="py-0 px-2" cols="2">
        <div class="title-form">Validade da senha</div>
        <v-menu
          ref="dtS"
          v-model="dtS"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
        > <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormattedS"
              dense
              v-mask="'##/##/####'"
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              label
              outlined
              v-bind="attrs"
              v-on="on"
              append-icon="mdi-calendar-blank"
              @blur="dateS = parseDate(dateFormattedS)"
              :rules="[formRules.typeDateFormated]"
            ></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="dateS" @input="formData.dadosAutorizacao.dataValidadeSenha = dateS" no-title scrollable></v-date-picker>
        </v-menu>
      </v-col>

      <v-col class="py-0 px-2" cols="3">
        <div class="title-form">Nº da guia na operadora</div>
        <v-text-field
          v-model="formData.dadosAutorizacao.numeroGuiaOperadora"
          outlined
          dense
          maxlength="20"
        ></v-text-field>
      </v-col>
      
     <!-- <v-col class="py-0 px-2" cols="2">
        <div class="title-form">Validad cart. beneficiário</div>
        <v-menu
          ref="dtB"
          v-model="dtB"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
        > <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormattedB"
              dense
              v-mask="'##/##/####'"
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              label
              outlined
              v-bind="attrs"
              v-on="on"
              append-icon="mdi-calendar-blank"
              @blur="dateA = parseDate(dateFormattedB)"
            ></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="dateB" @input="formData.dadosBeneficiario.atendimentoRN = dateB" no-title scrollable></v-date-picker>
        </v-menu>
      </v-col> -->

      <v-col cols="2"></v-col>

      <v-col class="py-0 px-2" cols="2">
        <div class="title-form">Nº da carteira</div>
        <v-text-field
          v-model="formData.dadosBeneficiario.numeroCarteira"
          outlined
          dense
        ></v-text-field>
      </v-col>

      <v-col class="py-0 px-2" cols="5">
        <div class="title-form">Nome beneficiário</div>
        <v-text-field
          v-model="formData.dadosBeneficiario.nomeBeneficiario"
          outlined
          dense
          maxlength="70"
        ></v-text-field>
      </v-col>

      <v-col class="py-0 px-2" cols="3">
        <div class="title-form">Cartão Nacional de Saúde</div>
        <v-text-field
          v-model="formData.dadosBeneficiario.numeroCNS"
          outlined
          dense
          maxlength="20"
        ></v-text-field>
      </v-col>
       <!-- CONSELHO PROFISSIONAL FORMULARIO   -->
      <v-col v-if="['SP-SADT'].includes(typeGuia)" class="py-0 px-2" cols="4">
        <div class="title-form">Conselho profissional do solicitante</div>
        <v-select
          v-model="formData.profissionalSolicitante.conselhoProfissional"
          :menu-props="{ bottom: true, offsetY: true }"
          solo
          flat
          dense
          :items="dominiosList[getListIndex('dm_conselhoProfissional')].valores"
          item-text="descricao"
          item-value="valor"
          outlined
        ></v-select>
      </v-col>
      <v-col v-if="['Consulta'].includes(typeGuia)" class="py-0 px-2" cols="4">
        <div class="title-form">Conselho profissional do Executante</div>
        <v-select  
          v-model="formData.profissionalExecutante.conselhoProfissional"
          :menu-props="{ bottom: true, offsetY: true }"
          solo
          flat
          dense
          :items="dominiosList[getListIndex('dm_conselhoProfissional')].valores"
          item-text="descricao"
          item-value="valor"
          outlined
        ></v-select>
      </v-col>

      <v-col v-if="['SP-SADT', 'Consulta'].includes(typeGuia)" class="py-0 px-2" cols="3">
        <div class="title-form">N° do Conselho do {{typeGuia == 'SP-SADT' ?'solicitante' :'executante'}}</div>
        <v-text-field
          v-model="formData.profissionalSolicitante.numeroConselhoProfissional"
          outlined
          dense
          v-if="typeGuia == 'SP-SADT'"
        ></v-text-field>
        <v-text-field
          v-model="formData.profissionalExecutante.numeroConselhoProfissional"
          outlined
          dense
          v-else
        ></v-text-field>
      </v-col>

      <v-col v-if="['SP-SADT', 'Consulta'].includes(typeGuia)" class="py-0 px-2" cols="3">
        <div class="title-form">Código CBO do {{typeGuia == 'SP-SADT' ?'solicitante' :'executante'}}</div>
        <v-select v-if="typeGuia == 'SP-SADT'"
          v-model="formData.profissionalSolicitante.CBOS"
          :menu-props="{ bottom: true, offsetY: true }"
          solo
          flat
          dense
          :items="dominiosList[getListIndex('dm_CBOS')].valores"
          item-text="descricao"
          item-value="valor"
          outlined
        ></v-select>
        <v-select v-else
          v-model="formData.profissionalExecutante.CBOS"
          :menu-props="{ bottom: true, offsetY: true }"
          solo
          flat
          dense
          :items="dominiosList[getListIndex('dm_CBOS')].valores"
          item-text="descricao"
          item-value="valor"
          outlined
        ></v-select>
      </v-col>
      <!-- FINAL DO FORMULARIO -->

      <v-col v-if="typeGuia != 'Internação'" cols="2"></v-col>

      <v-col class="py-0 px-2" cols="4">
        <div class="title-form">Tipo ident. do executante</div>
        <v-select
          outlined
          dense
          :menu-props="{ bottom: true, offsetY: true }"
          class="pa-0"
          v-model="formData.contratadoExecutante.tipoCodigo"
          :items="tiposIdentificacao"
          item-text="descricao"
          item-value="valor"
        ></v-select>
      </v-col>

      <v-col class="py-0 px-2" cols="3">
        <div class="title-form">{{formData.contratadoExecutante.tipoCodigo == null || formData.contratadoExecutante.tipoCodigo == '' ? 'Identificação do Prestador' : labelIdentificacao[formData.contratadoExecutante.tipoCodigo]}}</div>
        <v-text-field
          v-if="formData.contratadoExecutante.tipoCodigo != '' && formData.contratadoExecutante.tipoCodigo !=  null"
          v-model="formData.contratadoExecutante.codigo"
          v-mask="formData.contratadoExecutante.tipoCodigo == 'codigoPrestadorNaOperadora'?'##########' : (formData.contratadoExecutante.tipoCodigo == 'CNPJ' ?'##.###.###/####-##' :'###.###.###-##')"
          outlined
          dense
        ></v-text-field>
        <v-text-field
          v-else
          outlined
          dense
          disabled
          placeholder="Tipo de identificação do executante"
        ></v-text-field>
      </v-col>

      <v-col v-if="['Internação', 'Honorários'].includes(typeGuia)" class="py-0 px-2" cols="2">
        <div class="title-form">Data início faturamento</div>
        <v-menu
          ref="dtI"
          v-model="dtI"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
        > <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormattedI"
              dense
              v-mask="'##/##/####'"
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              label
              outlined
              v-bind="attrs"
              v-on="on"
              append-icon="mdi-calendar-blank"
              @blur="dateI=parseDate(dateFormattedI)"
              :rules="[formRules.typeDateFormated]"
            ></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="dateI" @input="formData.dadosInternacao.dataInicioFaturamento = dateI" no-title scrollable></v-date-picker>
        </v-menu>
      </v-col>

      <v-col v-if="['Internação', 'Honorários'].includes(typeGuia)" class="py-0 px-2" cols="2">
        <div class="title-form">Data fim faturamento</div>
        <v-menu
          ref="dtF"
          v-model="dtF"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
        > <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormattedF"
              dense
              v-mask="'##/##/####'"
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              label
              outlined
              v-bind="attrs"
              v-on="on"
              append-icon="mdi-calendar-blank"
              @blur="dateF = parseDate(dateFormattedF)"
              :rules="[formRules.typeDateFormated]"
            ></v-text-field>
          </template>
          <v-date-picker color="primary" v-model="dateF" @input="formData.dadosInternacao.dataFinalFaturamento = dateF" no-title scrollable></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
export default {
  data() {
    return {
      dateFormattedA: null,
      dateA: null,
      dtA: false,
      dateFormattedS: null,
      dateS: null,
      dtS: false,
      dateFormattedI: null,
      dateI: null,
      dtI: false,
      dateFormattedF: null,
      dateF: null,
      dtF: false,
      tiposIdentificacao: [
        {descricao: 'Selecione', valor: ''},
        {descricao: 'Cód. na operadora', valor: 'codigoPrestadorNaOperadora'},
        {descricao: 'CNPJ', valor: 'CNPJ'},
        {descricao: 'CPF', valor: 'CPF'}
      ],
      labelIdentificacao:{
       codigoPrestadorNaOperadora: 'Cód. na operadora',
       CNPJ: 'CNPJ',
       CPF: 'CPF',
      }
    }
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules
    }),
  }, 
  filters: {
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  mounted() {
    this.dateA = this.formData.dadosAutorizacao.dataAutorizacao
    this.dateS = this.formData.dadosAutorizacao.dataValidadeSenha
    if (this.typeGuia == 'Internação' || this.typeGuia == 'Honorários') {
      this.dateI = this.formData.dadosInternacao.dataInicioFaturamento
      this.dateF = this.formData.dadosInternacao.dataFinalFaturamento
    }
  },
  watch: {
    dateA(val){
      this.dateFormattedA = this.formatDate(val)
    },
    dateS(val){
      this.dateFormattedS = this.formatDate(val)
    },
    dateI(val){
      this.dateFormattedI = this.formatDate(val)
    },
    dateF(val){
      this.dateFormattedF = this.formatDate(val)
    },
    formData(){
      this.dateA = this.formData.dadosAutorizacao.dataAutorizacao
      this.dateS = this.formData.dadosAutorizacao.dataValidadeSenha
      if (this.typeGuia == 'Internação' || this.typeGuia == 'Honorários') {
        this.dateI = this.formData.dadosInternacao.dataInicioFaturamento
        this.dateF = this.formData.dadosInternacao.dataFinalFaturamento
      }
    }
  },
  props: {
    formData: Object,
    formatDate: Function,
    parseDate: Function,
    typeGuia: String,
    camposList: Array,
    dominiosList: Array,
    getListIndex: Function
  }
};
</script>

<style>
#guia-update-form
.title-form {
  font-size: 0.90rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
</style>